export default "__VITE_ASSET__3bc687f6__"